import React, { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import styles from '../../styles/Categories.module.css';
import { isNumber } from 'lodash';
import { useRouter } from 'next/router';
import {
  CategoriesMenuButton,
  CategoriesMenuMobileContainer,
  SideMenu,
  SideMenuBGColorEnum,
  SideMenuV3,
  SideMenuV3BGColorEnum,
  CategoriesMenuMobileContainerV3,
} from '@desquared/wave-components-library';
import { useTranslations } from 'next-intl';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function CategoriesMenu({
  categories = [],
  slug,
  featuredAmmount,
  selectedCategoryTree,
  isFirstLevel = false,
  routeSetter,
  sideMenuStyles,
}) {
  const t = useTranslations('common.categories_menu');
  const hasIcons = process.env.hasMenuIcons;

  const selectedCategoryIndex = selectedCategoryTree
    ? categories.findIndex(i => i._id === selectedCategoryTree?.[0]?._id)
    : undefined;
  const selectedSubCategoryIndex = selectedCategoryTree
    ? categories
        .find(i => i._id === selectedCategoryTree?.[0]?._id)
        ?.subcategories?.findIndex(i => i._id === selectedCategoryTree?.[1]?._id)
    : undefined;
  const router = useRouter();
  const categoriesWording = t('header');
  const categoriesSingleWording = t('categories_title');

  const [firstLevel, setFirstLevel] = useState(!isNumber(selectedCategoryIndex));
  const [showMobile, setShowMobile] = useState(false);
  const [myCategory, setCategory] = useState(selectedCategoryIndex);
  const [pickedSubCategory, setpickedSubCategory] = useState(selectedSubCategoryIndex);
  const [myUrl, setMyUrl] = useState('');
  const isRtl = useIsRtl();

  const currentCategoryName = selectedCategoryTree?.[selectedCategoryTree?.length - 1]?.name;

  // when we navigate to another page the category indexes change from getStaticProps
  // but the local state remains the same because there is no page refresh
  useEffect(() => {
    setCategory(selectedCategoryIndex);
    setpickedSubCategory(selectedSubCategoryIndex);
  }, [selectedCategoryIndex, selectedSubCategoryIndex]);

  const categoriesWithOnClick = useMemo(() => {
    return categories.map(category => {
      const newCategory = { ...category };

      if (!newCategory.subcategories) {
        newCategory.subcategories = [
          {
            text: t('all_categories'),
            fullSlug: '',
            slug: '',
            onClick: () => {
              router.push(`/${newCategory.fullSlug}`);
            },
          },
        ];
      }

      newCategory.subcategories = newCategory.subcategories.map(subcategory => ({
        ...subcategory,
        onClick: () => {
          setShowMobile(false);

          if (newCategory.slug === 'offers') {
            router.push('/offers');
            return;
          }

          if (subcategory?.text === t('all_categories')) {
            if (routeSetter) {
              const catArr = newCategory.fullSlug.split('/');
              catArr.shift();
              routeSetter({ slug: catArr, subcategory: undefined });
              return;
            }

            router.push('/' + newCategory.fullSlug);
            return;
          }

          const subCategoryArr = subcategory.fullSlug.split('/');
          subCategoryArr.shift();

          if (routeSetter) {
            routeSetter({ slug: subCategoryArr, subcategory: undefined });
          } else {
            router.push(`/${subcategory.fullSlug}`);
          }
        },
      }));

      return newCategory;
    });
  }, [categories, t, router, routeSetter]);

  const backClick = () => {
    setMyUrl('');
    setFirstLevel(true);
    setCategory(-1);
  };

  return (
    <>
      <div style={{ width: '100%' }} className={cn(styles.categoriesMobileMenu)}>
        <CategoriesMenuButton
          title={currentCategoryName ?? categoriesWording}
          onBack={() => {
            setShowMobile(true);
          }}
        />

        {process.env.sideMenuVersion === 'v1' ? (
          <CategoriesMenuMobileContainer
            classOption={cn(styles.overflow)}
            onBack={backClick}
            featuredTitle={featuredAmmount > 0 ? t('featured_title') : null}
            featuredAmmount={featuredAmmount > 0 ? featuredAmmount : null}
            title={categoriesWording}
            categoriesWording={categoriesSingleWording}
            isShowing={showMobile}
            setIsShowing={setShowMobile}
            onClose={() => {
              // if (slug) {
              //   if (slug[0] !== myUrl) {
              //     router.push(`/categories/${myUrl}`);
              //   }
              // } else {
              //   if (myUrl !== '') {
              //     router.push(`/categories/${myUrl}`);
              //   }
              // }
            }}
            menuProps={{
              Items: categoriesWithOnClick,
              hasIcons: hasIcons,
              bgColor: SideMenuBGColorEnum.Grayscale,
              firstLevel: firstLevel,
              pickedSubCategory: pickedSubCategory,
              category: myCategory,
              setCategory: categoryIndex => {
                setCategory(categoryIndex);
                setMyUrl(categories[categoryIndex].slugAscii);
                if (slug)
                  if (slug[0] !== categories[categoryIndex].slugAscii) {
                    setpickedSubCategory(-1);
                  } else {
                    categories[categoryIndex].subcategories?.map((subcategory, index) => {
                      if (subcategory.slugAscii === slug[1]) {
                        setpickedSubCategory(index);
                      }
                    });
                  }
              },
              setFirstLevel: isFirstLevel => {
                setFirstLevel(isFirstLevel);
              },
              setpickedSubCategory: setpickedSubCategory,
            }}
            isRtl={isRtl}
          />
        ) : (
          <CategoriesMenuMobileContainerV3
            classOption={cn(styles.overflow)}
            featuredTitle={featuredAmmount > 0 ? t('featured_title') : null}
            featuredAmmount={featuredAmmount > 0 ? featuredAmmount : null}
            title={categoriesWording}
            categoriesWording={categoriesSingleWording}
            isShowing={showMobile}
            setIsShowing={setShowMobile}
            onClose={() => {
              // if (slug) {
              //   if (slug[0] !== myUrl) {
              //     router.push(`/categories/${myUrl}`);
              //   }
              // } else {
              //   if (myUrl !== '') {
              //     router.push(`/categories/${myUrl}`);
              //   }
              // }
            }}
            menuProps={{
              Items: categoriesWithOnClick,
              hasIcons: hasIcons,
              bgColor: SideMenuV3BGColorEnum.Grayscale,
              firstLevel: firstLevel,
              pickedSubCategory: pickedSubCategory,
              category: myCategory,
              setCategory: categoryIndex => {
                setCategory(categoryIndex);
                setMyUrl(categories[categoryIndex].slugAscii);
                if (slug)
                  if (slug[0] !== categories[categoryIndex].slugAscii) {
                    setpickedSubCategory(-1);
                  } else {
                    categories[categoryIndex].subcategories?.map((subcategory, index) => {
                      if (subcategory.slugAscii === slug[1]) {
                        setpickedSubCategory(index);
                      }
                    });
                  }
              },
              setFirstLevel: isFirstLevel => {
                setFirstLevel(isFirstLevel);
              },
              setpickedSubCategory: setpickedSubCategory,
            }}
            isRtl={isRtl}
          />
        )}
      </div>

      <div
        style={{
          ...(sideMenuStyles && sideMenuStyles),
        }}
        className={cn(styles.categoriesDesktopMenu)}
      >
        {process.env.sideMenuVersion === 'v1' ? (
          <SideMenu
            classOption={cn(styles.fixedPosition)}
            Items={categoriesWithOnClick}
            hasIcons={hasIcons}
            bgColor={SideMenuBGColorEnum.Grayscale}
            firstLevel={firstLevel}
            isInCategories={isFirstLevel}
            pickedSubCategory={pickedSubCategory}
            hasNoIconsHeader={t('no_icons_header')}
            category={myCategory}
            setCategory={categoryIndex => {
              setCategory(categoryIndex);
            }}
            setFirstLevel={isFirstLevel => {
              setFirstLevel(isFirstLevel);
            }}
            setpickedSubCategory={setpickedSubCategory}
            featuredAmmount={featuredAmmount > 0 ? featuredAmmount : null}
            featuredTitle={featuredAmmount > 0 ? t('featured_title') : null}
            title={featuredAmmount > 0 ? t('categories_title') : null}
            isRtl={isRtl}
          />
        ) : (
          <SideMenuV3
            classOption={cn(styles.fixedPosition)}
            Items={categoriesWithOnClick}
            hasIcons={hasIcons}
            bgColor={SideMenuV3BGColorEnum.Grayscale}
            firstLevel={firstLevel}
            isInCategories={isFirstLevel}
            pickedSubCategory={pickedSubCategory}
            hasNoIconsHeader={t('no_icons_header')}
            category={myCategory}
            setCategory={categoryIndex => {
              setCategory(categoryIndex);
            }}
            setFirstLevel={isFirstLevel => {
              setFirstLevel(isFirstLevel);
            }}
            setpickedSubCategory={setpickedSubCategory}
            featuredAmmount={featuredAmmount > 0 ? featuredAmmount : null}
            featuredTitle={featuredAmmount > 0 ? t('featured_title') : null}
            title={featuredAmmount > 0 ? t('categories_title') : null}
            isRtl={isRtl}
          />
        )}
      </div>
    </>
  );
}
